import React, {Component} from 'react';
import {withRouter} from 'react-router';

import Datatables from './Datatablesjs';
import {admins} from '../../api/api';
import {routeUrl} from '../routeUrl';

@withRouter
export default class Admins extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
    };
  }

  componentDidMount() {
    admins((err, result) => {
      if (err) {
        console.log('get history err!');
        this.props.router.push(routeUrl.login);
      } else {
        this.setState({data: result.admins});
      }
    });
  }

  render() {
    return (
        <div>
          <Datatables data={this.state.data} />
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/admin/Admins.js